(function () {
  'use strict';
  // Instant guard: Exit immediately (0ms) if not landing with a ?variant= query parameter
  if (!location.search || location.search.indexOf('variant=') === -1) return;

  function getVariants() {
    // Path 1: the product template's inline `const variants = [...]`
    try { if (typeof variants !== 'undefined' && Array.isArray(variants)) return variants; } catch (e) {}
    // Path 2: the picker's embedded JSON (<variant-radios><script type="application/json">)
    var tag = document.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    if (tag) { try { return JSON.parse(tag.textContent); } catch (e) {} }
    return null;
  }

  function rescue() {
    var vid = new URLSearchParams(location.search).get('variant');
    if (!vid) return;
    var list = getVariants();
    if (!list) return;
    var cur = null, i;
    for (i = 0; i < list.length; i++) if (String(list[i].id) === vid) { cur = list[i]; break; }
    if (!cur || cur.option3 !== 'UPCA') return;          // not a dead-twin landing
    var twin = null;
    for (i = 0; i < list.length; i++) {
      var v = list[i];
      if (v.option3 === 'UPCO' && v.option1 === cur.option1 && v.option2 === cur.option2) { twin = v; break; }
    }
    if (!twin) return;                                    // both twins dead -> genuine sold-out, leave it

    // Preserve all existing query parameters (UTM tags, ad IDs, etc.) and update only the variant ID
    var p = new URLSearchParams(location.search);
    p.set('variant', twin.id);

    // Re-select via the hidden UPC radio so the theme's own variant JS updates
    // the form id, button state, price and URL through its normal code path.
    var radio = document.querySelector('input[name="UPC"][value="UPCO"], input[value="UPCO"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      // Ensure the URL maintains all query parameters even if theme's variant JS replaced the URL
      history.replaceState(null, '', location.pathname + '?' + p.toString());
    } else {
      // Fallback (dropdown-type picker): set the form id directly and clean the URL
      var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (idInput) {
        idInput.value = twin.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        history.replaceState(null, '', location.pathname + '?' + p.toString());
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rescue);
  else rescue();
})();
